module.exports = __webpack_public_path__ + "img/Crew-3.54acde49.png";